<template>
  <div class="installation-container tab-body flex-column h-100 wprepoinstaller-container">
    <div class="custom-tab-body-cont">
      <div class="spinner-cont" v-if="isLoading">
        <spinner size="medium" message="Loading..."></spinner>
      </div>
      <b-row v-for="(item,index) of items" :key="item.slug" v-else class="wp-item-row">
            <b-col cols="7">
              <b-form-checkbox :value="item.download_link" size="m" v-model="selectedItems">

              <div class="item-name">{{item.name}}
                <a @click="addToFavorite(item,index)" v-b-tooltip.hover title="Add to Favourite">
                  <heart-icon class="icon-default heart" v-bind:class="{filled:item.isFavorite}"></heart-icon>
                </a>
              </div>
              <span class="item-author">By
                <a @click="openAuthorLink(item)" class="link">{{item.author |striphtml}} </a>
              </span>
              </b-form-checkbox>

            </b-col>
            <b-col class="item-version">
              {{item.version}}
            </b-col>
            <b-col class="rating-container">
              <div class="star-rating text-right">
                <div v-b-tooltip.hover :title="'Based on '+item.num_ratings+' ratings'" class="d-inline">
                  <label class="star-rating__star" v-for="(rating,index) of ratings" :key="index" :class="{'is-selected': ((item.rating/20 >= rating) && item.rating != null)}">
                    <input class="star-rating star-rating__checkbox" type="radio" value="2">★</label>
                </div>
              </div>
            </b-col>
      </b-row>
    </div>
    <div class="custom-tab-body-footer">
        <div class="d-flex align-items-center flex-row-reverse">
            <div><b-button variant="primary" @click="install" :disabled="$v.selectedItems.$invalid||$v.sites.$invalid">Install</b-button></div>
            <div class="selected-label">{{selectedItems.length}} selected</div>
            <div class="mr-3">
              <b-form-checkbox v-model="activate" size="m" class="installoptions darkbg">Activate after installation</b-form-checkbox>
            </div>
            <div class="mr-3">
              <b-form-checkbox v-model="clearDestination" size="m" class="installoptions darkbg">Overwrite if {{this.type=='plugins'?'plugin':'theme'}} exist</b-form-checkbox>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import HeartIcon from "../../assets/heart.svg";
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
Vue.filter("striphtml", function(value) {
  var div = document.createElement("div");
  div.innerHTML = value;
  var text = div.textContent || div.innerText || "";
  return text;
});

export default {
  name: "wprepoinstaller",
  props: ["type", "searchText", "sites"],
  components: {
    HeartIcon
  },
  created() {
    
    this.loadFeatured();
  },
  mixins: [validationMixin],
  validations: {
    selectedItems: {
      required
    },
    sites: {
      required
    }
  },
  data() {
    return {
      items: [],
      isLoading: true,
      clearDestination: false,
      activate: false,
      selectedItems: [],
      ratings: [1, 2, 3, 4, 5]
    };
  },
  watch: {
    searchText(newValue) {
      this.isLoading = true;
      let payload = {
        ignorePanelHistory: 1
      };
      payload.requiredData = {
        getWPRepositoryHTMLV3: {
          type: this.type,
          searchVar: 1,
          searchItem: newValue
        }
      };
      this.$store
        .dispatch("sendAction", payload)
        .then(response => {
          // console.log(
          //   "featured list loaded",
          //   response.data.getWPRepositoryHTMLV3
          // );
          this.items = response.data.getWPRepositoryHTMLV3;
          this.isLoading = false;
        })
        .catch(err => {
          
        });
    },
    type(){
      this.loadFeatured();
    }
  },
  methods: {
    loadFeatured() {
      this.isLoading = true;
      let payload = {
        ignorePanelHistory: true
      };
      payload.requiredData = {
        getWPRepositoryHTMLV3: {
          type: this.type,
          searchVar: 0,
          searchItem: "featured"
        }
      };
      this.$store
        .dispatch("sendAction", payload)
        .then(response => {
          console.log(
            "featured list loaded",
            response.data.getWPRepositoryHTMLV3
          );
          this.items = response.data.getWPRepositoryHTMLV3;
          this.isLoading = false;
        })
        .catch(err => {
          
        });
    },
    openAuthorLink(item) {
      window.open(item.author_profile, "_blank");
    },
    install() {
      this.$emit("onInstall", {
        selectedItems: this.selectedItems,
        type: this.type,
        clearDestination: this.clearDestination,
        activate: this.activate
      });
    },
    addToFavorite(item, index) {
      item.isFavorite = true;
      this.$emit("addFavorite", {
        name: item.name,
        slug: item.slug,
        URL: item.download_link,
        type: this.type
      });
      Vue.set(this.items, index, item);
    }
  }
};
</script>

<style scoped>
/* style star ratting component */
</style>
